module.exports = __webpack_public_path__ + "static/media/not-found.defc1297.jpg";